import {AxiosPromise} from "axios";
import {CONSTANT_CONFIG} from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.AUTH_SERVER_PREFIX}/organogram`
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    dropdown: () => `${RESOURCE_ENDPOINT}/dropdown`,
     dropdownAll: () => `${RESOURCE_ENDPOINT}/dropdown-all`,
    getOrganogramTree: () => `${RESOURCE_ENDPOINT}/getOrganogramTree`,
    getCostCenterTree: () => `${RESOURCE_ENDPOINT}/getCostCenterTree`,
    syncDoptarOrganogram: () => `${RESOURCE_ENDPOINT}/syncDoptarOrganogram`,
    getOrganogramByOrganizationId: (organizationId: any) => `${RESOURCE_ENDPOINT}/getOrganogramListByOrganizationId/${organizationId}`
}

export default class OrganogramApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();
        return HttpService.get(url, params, headers);
    }

    public getOrganogramTree = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getOrganogramTree();
        return HttpService.get(url, params, headers);
    }

    public getCostCenterTree = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getCostCenterTree();
        return HttpService.get(url, params, headers);
    }

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    }

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    }

    public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    }

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    }

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    }

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    }

    public dropdown = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.dropdown();
        return HttpService.get(url, params, headers);
    }

   public dropdownAll = (params = {}, headers = {}): AxiosPromise<any> => {
           const url = endpoints.dropdownAll();
           return HttpService.get(url, params, headers);
       };

    public syncDoptarOrganogram = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.syncDoptarOrganogram();
        return HttpService.get(url, params, headers);
    }

    public getOrganogramByOrganizationId = (organizationId:any): AxiosPromise<any> => {
        const url = endpoints.getOrganogramByOrganizationId(organizationId);
        return HttpService.get(url);
    }
}
